export const ORDERS_FETCHED = "RaasOrdersScreen/ORDERS_FETCHED";
export const ORDERS_CONSTANTS_FETCHED = "RaasOrdersScreen/ORDERS_CONSTANTS_FETCHED";